define([
  '../core_module',
],
function (coreModule) {
  'use strict';

  coreModule.default.directive('confirmClick', function() {
    return {
      restrict: 'A',
      link: function(scope, elem, attrs) {
        elem.bind('click', function() {
          var message = attrs.confirmation || "Are you sure you want to do that?";
          if (window.confirm(message)) {
            var action = attrs.confirmClick;
            if (action) {
              scope.$apply(scope.$eval(action));
            }
          }
        });
      },
    };
  });
});



//////////////////
// WEBPACK FOOTER
// ./public/app/core/directives/confirm_click.js
// module id = 527
// module chunks = 5